<template>
  <b-container>
    <b-row class="mb-2">
      <b-col>
        <h2 class="my-3">Please let us know about your arrest and release</h2>
      </b-col>
    </b-row>
    <div v-if="submitted">
    <b-row class="mb-2">
      <b-col>
        <p>Thank you for completing this form.</p>
      </b-col>
    </b-row>
    </div>
    <div v-else>
    <b-row class="mb-2">
      <b-col>
        <b-form-group id="label-fullname" label="Name / Alias" label-for="input-fullname" :invalid-feedback="isValidName.reason" :state="isValidName.valid">
          <b-form-input id="input-fullname" v-model="name" :state="isValidName.valid"></b-form-input>
        </b-form-group>
        <b-form-group id="label-datetime" label="When did this arrest take place?" label-for="input-datetime" :invalid-feedback="isValidDatetime.reason" :state="isValidDatetime.valid">
          <datetime id="input-datetime" type="datetime" input-class="form-control" v-model="datetime" :state="isValidDatetime.valid" :max-datetime="new Date().toISOString()" />
        </b-form-group>
        <b-form-group id="label-location" label="Where did this arrest take place?" label-for="input-location" :invalid-feedback="isValidLocation.reason" :state="isValidLocation.valid">
          <b-form-input id="input-location" v-model="location" :state="isValidLocation.valid" placeholder="Place name"></b-form-input>
        </b-form-group>
        <b-form-group label="Named offence at time of arrest" label-for="input-offence">
          <b-form-input id="input-offence" v-model="offence"></b-form-input>
        </b-form-group>
        <b-form-group label="Terms of release">
          <b-form-radio-group v-model="termsOfRelease" stacked>
            <b-form-radio value="rui">Released under investigation (RUI)</b-form-radio>
            <b-form-radio value="charge">Charge</b-form-radio>
            <b-form-group v-if="hasCharges" label="Name charges:" label-for="input-charges">
              <b-form-input id="input-charges" v-model="charges"></b-form-input>
            </b-form-group>
            <b-form-radio value="noFurtherAction">No further action</b-form-radio>  
            <b-form-radio value="bail">Released on police bail</b-form-radio>
          </b-form-radio-group>
        <b-form-group v-if="bailed" label="Bail conditions" label-for="input-bail-conditions">
          <b-form-input id="input-bail-conditions" v-model="bailConditions"></b-form-input>
        </b-form-group>
        </b-form-group>
        <b-form-group label="Court date" label-for="input-court-date">
          <b-form-input id="input-court-date" v-model="courtDate"></b-form-input>
        </b-form-group>
        <b-form-group label="Name of court" label-for="input-court-location">
          <b-form-input id="input-court-location" v-model="courtLocation"></b-form-input>
        </b-form-group>
        <b-form-group id="label-police-station" label="Police Station" label-for="input-police-station"  :invalid-feedback="isValidPoliceStation.reason" :state="isValidPoliceStation.valid">
          <StationSearch id="input-police-station" v-model="policeStation"></StationSearch>
        </b-form-group>
        <b-form-group label="Nearest City or Region to home address (if any)" label-for="input-nearest-city">
          <b-form-input id="input-nearest-city" v-model="nearestCity"></b-form-input> 
        </b-form-group>
        <b-form-checkbox v-model="hasAnyInjuries">Any injuries?</b-form-checkbox>  
        <b-form-group v-if="hasAnyInjuries" label="Name injuries:" label-for="input-anyInjuries">
          <b-form-input id="input-anyInjuries" v-model="anyInjuries"></b-form-input>
        </b-form-group>
        <b-form-checkbox v-model="hasAdverseEvents">Adverse events?</b-form-checkbox>  
        <b-form-group v-if="hasAdverseEvents" label="Name adverse events:" label-for="input-adverseEvents">
          <b-form-input id="input-adverseEvents" v-model="adverseEvents"></b-form-input>
        </b-form-group>
        <b-form-checkbox v-model="heldMoreThan24Hours">Held more than 24hr?</b-form-checkbox>  

        <b-form-group label="How many protestors were brought to this station with you?" label-for="input-number-protestors">
          <b-form-input type="number" id="input-number-protestors" v-model="numberProtestors"></b-form-input>
        </b-form-group>

        <b-form-group label="What solicitor/law firm did you use during your time in custody?" label-for="input-law-firm">
          <b-form-input id="input-law-firm" v-model="lawFirmUsed"></b-form-input>
        </b-form-group>

        <b-form-group id="label-contact" :invalid-feedback="isValidGdprConsent.reason" :state="isValidGdprConsent.valid">
          <b-form-checkbox v-model="gdprConsent" :state="isValidGdprConsent.valid">{{ consentNotice }}</b-form-checkbox>

          <b-form-group label="Email:" label-for="input-by-email">
            <b-form-input id="input-by-email" v-model="contactByEmail"></b-form-input>
          </b-form-group>

          <b-form-group label="Phone:" label-for="input-by-phone">
            <b-form-input id="input-by-phone" v-model="contactByPhone"></b-form-input>
          </b-form-group>
        </b-form-group> 
      </b-col>
    </b-row>
    <b-row class="my-4" v-if="multipleSupportOrgs">
      <b-col>
        <h4>Further Support</h4>
        <b-form-group id="label-support-org" label="Please indicate which organisation you would like to provide post-arrest support to you" :invalid-feedback="isValidSupportOrganisation.reason" :state="isValidSupportOrganisation.valid">
          <b-form-radio-group v-model="supportOrganisation" :state="isValidSupportOrganisation.valid" stacked>
            <div v-for="org in configuredSupportOrganisations" :key="org.shortName">
              <b-row>
                <b-col>
                  <b-form-radio :value="org.shortName" :state="isValidSupportOrganisation.valid">{{ org.name }}</b-form-radio>
                </b-col>
                <b-col>
                  <p>{{ org.information }}</p>
                </b-col>
              </b-row>
            </div>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="my-4">
      <b-col>
        <b-button block variant="primary" v-on:click="submitReport" :disabled="isSubmitting">Submit post-arrest report <b-spinner v-if="isSubmitting" label="Spinning"></b-spinner></b-button>
      </b-col>
    </b-row>
    <b-row class="my-4" v-if="errors.length > 0">
      <b-col>
        <b-alert show variant="danger">
          <p>Your report was not submitted for the following reasons:</p>
          <ul>
            <li v-for="error in errors" v-bind:key="error">{{ error }}</li>
          </ul>
        </b-alert>
      </b-col>
    </b-row>
    </div>
    <div id="footer">
      <b-row align-v="end" class="mx-2">
        <p v-html="privacyNotice">
        </p>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import StationSearch from '../../components/StationSearch.vue'
const config = require('../../../../config/site_config.js');

export default {
  name: 'ArresteeReport',
  components: {
    StationSearch,
  },
  data () {
    return {
      name: null,
      datetime: null,
      location: null,
      offence: null,
      termsOfRelease: null,
      charges: null,
      bailConditions: null,
      courtDate: null,
      courtLocation: null,
      policeStation: null,
      nearestCity: null,
      hasAdverseEvents: false,
      adverseEvents: null,
      hasAnyInjuries: false,
      anyInjuries: null,
      heldMoreThan24Hours: false,
      numberProtestors: null,
      lawFirmUsed: null,
      gdprConsent: null,
      contactByEmail: null,
      contactByPhone: null,
      supportOrganisation: null,
      submitted: false,
      isSubmitting: false,
      errors: [],
      consentNotice: config.legalNotices.find(ln => ln.isActive).arresteeConsentNotice, 
      privacyNotice: config.legalNotices.find(ln => ln.isActive).privacyNotice,
      configuredSupportOrganisations: config.supportOrganisations.filter(org => org.isActive)
    }
  },
  computed: {
    hasCharges () {
      return this.termsOfRelease != null && this.termsOfRelease.includes('charge')
    },
    bailed() {
      return this.termsOfRelease != null && this.termsOfRelease.includes('bail')
    },
    isValidName () {
      if (this.name == null) {
        return { valid: null }
      } else if (this.name == '') {
        return { valid: false, reason: 'A name must be provided.' }
      } else {
        return { valid: true }
      }
    },
    isValidDatetime () {
      if (this.datetime == null) {
        return { valid: null }
      } else if (this.datetime == '') {
        return { valid: false, reason: 'Please select a date' }
      } else {
        return { valid: true }
      }
    },
    isValidLocation () {
      if (this.location == null) {
        return { valid: null }
      } else if (this.location == '') {
        return { valid: false, reason: 'Please enter a location' }
      } else {
        return { valid: true }
      }
    },
    isValidGdprConsent() {
      if (this.gdprConsent == null)
      {
        return {valid: null}
      }
      if (this.gdprConsent) {
        return {valid: true}
      }
      return {valid: false, reason: "Please consent to the data processing policy"}
    },
    isValidSupportOrganisation() {
      if (this.supportOrganisation == null)
      {
        return {valid: null}
      }
      if (this.supportOrganisation == '') {
        return {valid: false, reason: "Please select an organisation to support you after release"}
      }
      return {valid: true}
    },
    isValidPoliceStation() {
      if (this.policeStation == null || this.policeStation === '') {
        return {valid: false, reason: "Please select a police station"}
      }
      return {valid: true}
    },
    multipleSupportOrgs() {
      if (this.configuredSupportOrganisations.length == 0) {
        throw "No support orgs configured"
      }
      return this.configuredSupportOrganisations.length > 1;
    }
  },
  methods: {
    validate () {
      this.name = this.name || ''
      this.datetime = this.datetime || ''
      this.location = this.location || ''
      this.station = this.station || ''
      this.name = this.name || ''
      this.contactByEmail = this.contactByEmail || ''
      this.contactByPhone = this.contactByPhone || ''
      this.gdprConsent = this.gdprConsent || false
      this.supportOrganisation = this.selectedSupportOrg()
      if (!this.isValidName.valid) {
        this.$scrollTo('#label-fullname')
      } else if (!this.isValidDatetime.valid) {
        this.$scrollTo('#label-datetime')
      } else if (!this.isValidLocation.valid) {
        this.$scrollTo('#label-location')
      } else if (!this.isValidGdprConsent.valid) {
        this.$scrollTo('#label-contact')
      } else if (!this.isValidSupportOrganisation.valid) {
        this.$scrollTo('#label-support-org')
      } else if (!this.isValidPoliceStation.valid) {
        this.$scrollTo('#label-police-station')
      }

      return this.isValidDatetime.valid && 
        this.isValidLocation.valid && 
        this.isValidName.valid && 
        this.isValidGdprConsent.valid && 
        this.isValidSupportOrganisation.valid &&
        this.isValidPoliceStation.valid

    },
    submitReport () {
      if (this.isSubmitting) {
        return
      }
      if (!this.validate()) {
        this.errors = ["Please correct errors in the form before submitting."]
        return
      }
      const dateParts = /([\d-]*)T(\d+:\d+):.*Z/.exec(this.datetime)
      const date = dateParts[1]
      const time = dateParts[2]
      let report = {
        name: this.name,
        time: time,
        date: date,
        location: this.location,
        offence: this.offence,
        termsOfRelease: this.termsOfRelease,
        charges: this.hasCharges ? this.charges : '',
        bailConditions: this.bailConditions,
        courtDate: this.courtDate,
        courtLocation: this.courtLocation,
        policeStation: this.policeStation,
        nearestCity: this.nearestCity,
        hasAdverseEvents: this.hasAdverseEvents,
        adverseEvents: this.adverseEvents,
        hasAnyInjuries: this.hasAnyInjuries,
        anyInjuries: this.anyInjuries,
        heldMoreThan24Hours: this.heldMoreThan24Hours,
        numberProtestors: this.numberProtestors,
        lawFirmUsed: this.lawFirmUsed,
        contactByEmail: this.contactByEmail,
        contactByPhone: this.contactByPhone,
        supportOrganisation: this.supportOrganisation,
        gdprConsent: this.gdprConsent,
        submitted: this.submitted,
      }
      this.isSubmitting = true
      this.axios.post('/api/v1/arrestee_report', report).then(() => {
        this.isSubmitting = false
        this.submitted = true
      }, error => {
        this.isSubmitting = false
        this.errors = [error, error.response.data]
      })
    },
    selectedSupportOrg() {
      if (this.configuredSupportOrganisations.length == 0) {
        throw "There are no support organisations configured"
      } else if (this.configuredSupportOrganisations.length == 1) {
        return this.configuredSupportOrganisations[0].shortName
      }

      return this.supportOrganisation;
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
